const UserDetailPage = () => {
    return (
        <>
            <h1>Users detail</h1>
        </>
    );
};

export default UserDetailPage;
